var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page-table',{attrs:{"apiName":_vm.apiName,"nameRole":_vm.nameRoleEntity,"apiDeleteName":_vm.apiDeleteName,"titleTable":_vm.$t('Атрибуты объектов'),"paramsGetData":_vm.paramsGetData,"fieldLand":_vm.fieldLang,"hasLang":false,"prefixEdit":`/attrentity`,"prefixShow":`/attrentity`,"linkCreate":`/attrentity/create`,"keyTable":'attrEntityId'}})
}
var staticRenderFns = []

export { render, staticRenderFns }